import SuperJSON from "superjson";
import Id from "../types/Id";

export default class DataSourceId extends Id<"dataSource"> {}

SuperJSON.registerClass(DataSourceId, { identifier: "DataSourceId" });
